import classNames from "classnames/bind";
import { RichUtils } from "draft-js";
import isMatch from "lodash/isMatch";

import styles from "./styles/spoilersPlugin.sass";

const cx = classNames.bind(styles);

export default ({ readOnly = false, getWrapper = () => {} }) => {
  const spoilerElements = [];

  const readOnlyStyle = {
    color: "transparent",
    cursor: "pointer",
  };

  const showSpoilers = (e) => {
    e.preventDefault();
    while (spoilerElements.length) {
      const spoiler = spoilerElements.shift();
      spoiler.removeEventListener("click", showSpoilers);
      spoiler.style.color = "";
      spoiler.style.cursor = "";
      spoiler.classList.add(cx("isVisible"));
    }
  };

  const toggleHover = ({ type }) => {
    if (type === "mouseover") getWrapper().classList.add(cx("mouseOver"));
    else getWrapper().classList.remove(cx("mouseOver"));
  };

  const addSpoilerEventListeners = () => {
    const wrapper = getWrapper();
    if (wrapper == null) return;

    const styledElements = wrapper.querySelectorAll("[style]");
    for (let i = 0; i < styledElements.length; i += 1) {
      const styledElement = styledElements[i];
      if (isMatch(styledElement.style, readOnlyStyle)) {
        spoilerElements.push(styledElement);
      }
    }

    spoilerElements.forEach((spoilerElement) => {
      spoilerElement.addEventListener("mouseover", toggleHover);
      spoilerElement.addEventListener("mouseout", toggleHover);
      spoilerElement.addEventListener("click", showSpoilers);
      spoilerElement.classList.add(cx("spoiler"));
      setTimeout(() => { spoilerElement.classList.add(cx("hasTransition")); });
    });
  };

  const removeSpoilerEventListeners = () => {
    while (spoilerElements.length) {
      const spoiler = spoilerElements.shift();
      spoiler.removeEventListener("click", showSpoilers);
    }
  };

  const store = {
    getEditorState: () => {},
    setEditorState: () => {},
    getEditorRef: () => {},
  };

  const toggleSpoiler = () => {
    setTimeout(() => {
      store.getEditorRef().focus();
      store.setEditorState(RichUtils.toggleInlineStyle(store.getEditorState(), "SPOILER"));
    });
  };

  const spoilerStyleMap = {};
  if (readOnly) {
    Object.assign(spoilerStyleMap, readOnlyStyle);
  } else {
    spoilerStyleMap.backgroundColor = "#ffe8c9";
  }

  return {
    addSpoilerEventListeners,
    removeSpoilerEventListeners,
    toggleSpoiler,
    customStyleMap: { SPOILER: spoilerStyleMap },
    initialize: ({ getEditorState, setEditorState, getEditorRef }) => {
      store.getEditorState = getEditorState;
      store.setEditorState = setEditorState;
      store.getEditorRef = getEditorRef;
    },
  };
};
